import React, { useCallback } from 'react';

import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import Img from '@wconcept/wconcept-ui-renewal/components/atoms/Img';
import ModalTodayCloseBtn from '@wconcept/wconcept-ui-renewal/components/molecules/_btn/ModalTodayCloseBtn';
import { FullPopupButton } from '@wconcept/wconcept-common/models/renewal/popup';
import * as S from './style';

interface IProps {
  onSubmit?: () => void;
  onClose?: () => void;
  value?: {
    imgSrc?: string;
    fullPopupButtons?: FullPopupButton[];
    onClickButton?: (param: FullPopupButton, index: number) => void;
  };
}

const IntrobannerModal = ({ value, onSubmit, onClose }: IProps) => {
  // EVENT HANDLER : onSubmit
  const handleSubmit = useCallback(() => {
    if (typeof onSubmit === 'function') onSubmit();
  }, [onSubmit]);

  // EVENT HANDLER : onClose
  const handleClose = useCallback(() => {
    if (typeof onClose === 'function') onClose();
  }, [onClose]);

  return (
    <S.IntrobannerModal>
      <div className="content">
        <Img src={value?.imgSrc} />
        <div className="area-btn">
          {value?.fullPopupButtons?.map((button, index) => (
            <S.Box
              // eslint-disable-next-line react/no-array-index-key
              key={index}
              $buttonColor={button.buttonColor}
              $textColor={button.textColor}
            >
              <Button
                onClick={() => {
                  value?.onClickButton?.(button, index);
                }}
              >
                {button.buttonTitle}
              </Button>
            </S.Box>
          ))}
        </div>
      </div>
      <ModalTodayCloseBtn onTodayClose={handleSubmit} onClose={handleClose} />
    </S.IntrobannerModal>
  );
};

export default IntrobannerModal;
